export const FETCH_JOB_LIST_END = "setJobList";
export const LOAD_JOB_TO_EDIT = "loadJobToEdit";
export const RESET_DEFAULT_JOB_TO_EDIT = "resetDefaultJobToEdit";
export const RESET_DEFAULT_NEW_JOB = "resetDefaultNewJob";
export const SET_JOB = "setJob";
export const TOGGLE_EDIT_JOB_DIALOG = "toggleEditJobDialog";
export const TOGGLE_NEW_JOB_DIALOG = "toggleAddJobDialog";
export const UPDATE_ADD_JOB_FIELD = "updateAddJobField";
export const UPDATE_JOB_FIELD = "updateJobField";
export const UPDATE_MANAGE_JOB_FIELD = "updateManageJobField";
